import type { ManageUser } from "@/app/types/adminMenu";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  selectedUser: ManageUser | null;
  openNotification: boolean;
}

const initialState: UserState = {
  selectedUser: null,
  openNotification: false,
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setSelectedManageUser: (state, action: PayloadAction<ManageUser>) => {
      state.selectedUser = action.payload;
    },
    clearSelectedManageUser: (state) => {
      state.selectedUser = null;
    },
    handleNotification: (state) => {
      state.openNotification = !state?.openNotification;
    },
  },
});

export const { setSelectedManageUser, clearSelectedManageUser,handleNotification } =
  userSlice.actions;
export default userSlice.reducer;
